import { TReduxActions } from '../../types/redux';
import { SET_PAGE_TITLE } from '../../actions/seoData';
import { TSeoData } from '../../types/seoData';

export const initialState: TSeoData = {
  mainTitle: '',
  description: '',
  h1: '',
  keywords: '',
  seoText: '',
  title: '',
};

export function seoDataReducer(state = initialState, action: TReduxActions): TSeoData {
  switch (action.type) {
    case SET_PAGE_TITLE:
      return {
        ...state,
        h1: action.payload,
      };

    default:
      return state;
  }
}
